import { Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from './local-storage.service';
import { ToastrService } from './toastr.service';
import { Subject, firstValueFrom, timeout } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class WalletSessionSecurityService {
  private router = inject(Router);
  private localStorageService = inject(LocalStorageService);
  private toastr = inject(ToastrService);
  private http = inject(HttpClient);

  private invalidationInProgress = false;
  private readonly invalidationTick = signal(0);
  private readonly invalidationSubject = new Subject<void>();

  readonly sessionInvalidationSignal = this.invalidationTick.asReadonly();
  readonly sessionInvalidation$ = this.invalidationSubject.asObservable();

  markSessionActivity() {
    this.invalidationTick.update((value) => value + 1);
  }

  async forceSessionInvalidation(message?: string) {
    if (this.invalidationInProgress) {
      return;
    }

    this.invalidationInProgress = true;

    try {
      try {
        await firstValueFrom(
          this.http.post(`${environment.API_BASE_URL}auth/logout`, {}).pipe(
            timeout(3000)
          )
        );
      } catch (apiError) {
        console.error('Logout API call failed or timed out:', apiError);
      }
      this.invalidationSubject.next();
      this.localStorageService.removeToken();
      this.localStorageService.removeAuthenticatedWallet();
      this.localStorageService.removeSignupState();
      this.localStorageService.removeRegistrationState();
      this.localStorageService.removeNonceState();
      this.localStorageService.removeSignatureState();
      this.localStorageService.removeUserSessionState();
      this.localStorageService.removeMembershipState();
      this.localStorageService.removeHoldingsState();
      this.localStorageService.removeContributionState();
      this.localStorageService.removeWalletCachedData();
      if (message) {
        this.toastr.showToast(message, 'warning');
      }
      try {
        await this.router.navigateByUrl('/');
      } catch (navError) {
        console.error('Session invalidation navigation failed', navError);
      }
    } finally {
      this.invalidationTick.update((value) => value + 1);
      this.invalidationInProgress = false;
    }
  }

  isInvalidationInProgress(): boolean {
    return this.invalidationInProgress;
  }
}
